import { useEffect, useState } from "react";
import { useChristmasTheme } from "@/hooks/useChristmasTheme";

const GREETING_KEY = "vendeya-christmas-greeting-seen";

/**
 * Saludo navideño que se muestra una sola vez por dispositivo
 * (persistido en localStorage). Cierre elegante y accesible.
 */
export default function ChristmasGreeting() {
  const { enabled, animations } = useChristmasTheme();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!enabled || typeof window === "undefined") return;
    if (window.localStorage.getItem(GREETING_KEY)) return;
    const timer = window.setTimeout(() => setVisible(true), 700);
    return () => window.clearTimeout(timer);
  }, [enabled]);

  const close = () => {
    setVisible(false);
    try {
      window.localStorage.setItem(GREETING_KEY, "1");
    } catch {
      // ignorar
    }
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-[110] flex items-center justify-center px-4">
      <button
        type="button"
        aria-label="Cerrar saludo"
        onClick={close}
        className="absolute inset-0 cursor-pointer bg-foreground-950/50 backdrop-blur-sm"
      />
      <div
        role="dialog"
        aria-modal="true"
        aria-label="Bienvenida navideña"
        className={`relative w-full max-w-sm overflow-hidden rounded-2xl border border-accent-300/40 bg-background-50 p-8 text-center shadow-lift ${
          animations ? "animate-pop-in" : ""
        }`}
      >
        <div className="pointer-events-none absolute -right-6 -top-6 text-6xl opacity-20">
          🎄
        </div>
        <div className="pointer-events-none absolute -bottom-6 -left-4 text-6xl opacity-20">
          🎁
        </div>

        <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 text-3xl">
          🎄
        </span>
        <h2 className="mt-4 font-heading text-xl font-bold text-foreground-950">
          ¡Bienvenido a la Navidad de VendeYa!
        </h2>
        <p className="mt-2 text-sm text-foreground-600">
          Comparte, descubre y encuentra ese regalo perfecto esta temporada. 🎁
        </p>
        <button
          type="button"
          onClick={close}
          className="mt-6 w-full cursor-pointer whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-primary-600"
        >
          ¡Empezar a explorar!
        </button>
      </div>
    </div>
  );
}